module.exports = __webpack_public_path__ + "assets/img/6_555.f95c363c.jpg";